import { render, staticRenderFns } from "./infor-card.vue?vue&type=template&id=4172f8b2&scoped=true&"
import script from "./infor-card.vue?vue&type=script&lang=js&"
export * from "./infor-card.vue?vue&type=script&lang=js&"
import style0 from "./infor-card.vue?vue&type=style&index=0&id=4172f8b2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4172f8b2",
  null
  
)

export default component.exports